<template>
  <div>
    <div class="slider-nav" :class="listClass">
      <div class="slider-nav__container" ref="container">
        <nav-list class="slider-nav__list" ref="list" :itemList="itemList" :active="active" @select="onSelect" :style="styleObject"/>
      </div>

      <div class="slider-nav__action">
        <button type="button" class="slider-nav__btn btn-cloak" :disabled="disabledPrev" @click="onSelect(active - 1)">
          <icon class="slider-nav__icon" name="arrowPrev" width="24" height="14" />
        </button>
        <button type="button" class="slider-nav__btn btn-cloak" :disabled="disabledNext"  @click="onSelect(active + 1)">
          <icon class="slider-nav__icon" name="arrowNext" width="24" height="14" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../shared/Icon'
import NavList from '../shared/NavList'

export default {
  components: {
    Icon,
    NavList
  },
  props: {
    itemList: {
      type: Array,
      default: () => []
    },
    active: Number
  },
  data () {
    return {
      containerW: null,
      listW: null
    }
  },
  computed: {
    itemListLength () {
      return this.itemList.length
    },
    disabledPrev () {
      return this.active === 0
    },
    disabledNext () {
      return this.active === (this.itemListLength - 1)
    },
    listClass () {
      const half = Math.round(this.itemListLength / this.active)
      return half > this.active ? 'right' : 'left'
    },
    offset () {
      return this.listW - this.containerW
    },
    styleObject () {
      if (this.listClass === 'left') {
        return {
          transform: `translateX(-${this.offset}px)`
        }
      }

      return null
    }
  },
  watch: {
    '$mq.resize' () {
      this.setWidth()
    },
    active () {
      this.setWidth()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setWidth()
    })
  },
  methods: {
    onSelect (index) {
      this.$emit('select', index)
    },
    setWidth () {
      const { container, list } = this.$refs

      this.containerW = this.getWidth(container)
      this.listW = this.getWidth(list.$el)
    },
    getWidth (el) {
      return el ? el.getBoundingClientRect().width : null
    }
  }
}
</script>

<style lang="scss" scoped>
.slider-nav {
  position: relative;

  &__action {
    margin-left: auto;
    position: absolute;
    right: 0;
    top: 0;
  }

  &__btn {
    & + & {
      margin-left: 15px;
    }
  }

  &__container {
    height: 30px;
    margin-right: 78px;
    overflow: hidden;
    position: relative;

    &::after {
      content: '';
      height: 30px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 105px;

      .left & {
        background: linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
        left: 0;
      }

      .right & {
        background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
        right: 0
      }
    }
  }

  &__list {
    left: 0;
    position: absolute;
    top: 0;
    transform: translateX(0);
    white-space: nowrap;
    transition: transform 250ms ease;
  }

  &__icon {
    fill: $theme-red-100;
    transition: fill 250ms ease;

    :hover > & {
      fill: $theme-red-200;
    }

    :disabled > & {
      fill: $theme-gray-600;
    }
  }
}
</style>
